<button
  (click)="buttonClicked.emit($event)"
  [disabled]="disabled"
  [ngClass]="{'cui-button--with-icon': iconName}"
  class="cui-button cui-button--{{type}} cui-button--{{size}}"
  type="button">
  <span *ngIf="iconName" class="material-icons icon">{{iconName}}</span>
  <span>{{ label }}</span>
</button>
